import styled, { css } from 'styled-components';
import { vars } from '../../theme';
import { HBCalloutCardProps } from './HBCalloutCard.types';
import { newTextStyles } from '../HBText/HBText.styles';
import HBText from '../HBText/HBText';
import { CalloutLayout } from '../common/Callout/Callout.types';

export interface HBCalloutCardTheme {
    size: HBCalloutCardProps['size'];
    layout: HBCalloutCardProps['layout'];
    hasImage: boolean;
    withImagePadding: boolean;
}

interface CardSizeStyles {
    title: keyof typeof newTextStyles;
    body: keyof typeof newTextStyles;
    padding: string;
    titleAndBodyGap: string;
}

interface WithCardTheme {
    theme: HBCalloutCardTheme;
}
export const sizeStyles: Record<HBCalloutCardProps['size'], CardSizeStyles> = {
    sm: {
        title: 'title16',
        body: 'body14',
        padding: '16px',
        titleAndBodyGap: '4px'
    },
    md: {
        title: 'title18',
        body: 'body16',
        padding: '24px',
        titleAndBodyGap: '6px'
    },
    lg: {
        title: 'display24',
        body: 'body18',
        padding: '32px',
        titleAndBodyGap: '8px'
    }
} as const;

const layoutStyles: Record<
    Extract<CalloutLayout, 'default' | 'side-by-side'>,
    ReturnType<typeof css>
> = {
    default: css`
        flex-direction: column;
    `,
    'side-by-side': css`
        flex-direction: row-reverse;
        justify-content: space-between;
    `
};

function getCardContainerPadding({ size }: HBCalloutCardTheme) {
    const padding = sizeStyles[size].padding;
    return css`
        padding: ${padding};
    `;
}

export const CardContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-shrink: 1000000;
    ${props => getCardContainerPadding(props.theme as HBCalloutCardTheme)}
`;

export const CardTitleAndBodyContainer = styled.div<WithCardTheme>`
    display: flex;
    flex-direction: column;
    gap: ${props => sizeStyles[props.theme.size].titleAndBodyGap};
`;

export const CardContainer = styled.div<WithCardTheme>`
    position: relative;
    background-color: ${vars.colors.surface.container};
    overflow: hidden;
    border-radius: ${vars.radius.xs};
    box-shadow: ${vars.shadow['40']};
    display: flex;
    ${props => layoutStyles[props.theme.layout]}
`;

export const CardTitle = styled(HBText).attrs({
    color: 'text.primary',
    tag: 'h2'
})`
    // Override default h2 styles
    margin: 0;
`;

export const CardBody = styled(HBText).attrs({
    color: 'text.primary',
    tag: 'div'
})``;
